import React, { useContext } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import IconButton from '@material-ui/core/IconButton';
import AppContext from '../../../shared/contexts/AppContext';
import { DispatchActions } from '../../enums/DispatchActions';

const Header = () => {
	const appContext = useContext(AppContext);

	return (
		<Box sx={{ display: 'flex' }} mt={8} mb={6}>
			<Box sx={{ p: 1, flexGrow: 1 }}>
				<Typography variant='h4' fontWeight='fontWeightBold' gutterBottom>
					MERCHANT
				</Typography>
			</Box>
			<Box sx={{ p: 1 }}>
				<IconButton
					aria-label='delete'
					onClick={() =>
						appContext.dispatch({ type: DispatchActions.OPEN_CART })
					}
				>
					<ShoppingCartOutlinedIcon />
				</IconButton>
			</Box>
		</Box>
	);
};

export default Header;
